import { Component, OnInit } from '@angular/core';
import { ProductService } from 'src/app/services/product.service';
import { Router, ActivatedRoute } from "@angular/router";
import { ProductModelServer, ServerResponse } from 'src/app/models/product.model';
import { CartService } from "../../services/cart.service";
import { Category, CategoryModelServer } from 'src/app/models/category.model';
import { CategoryService } from 'src/app/services/category.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-category',
    templateUrl: './category.component.html',
    styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {

    imageBaseUrl = environment.imageBaseUrl;

    public category: Category;
    products: ProductModelServer[] = [];
    categories: any[] = [];
    categoryId: number;
    categoryName: string;

    constructor(
        private productService: ProductService,
        private router: Router,
        private cartService: CartService,
        private categoryService: CategoryService,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        // Fetch all categories
        this.categoryService.getAllCategories().subscribe((data: any[]) => {
            this.categories = data;
            console.log('category data', this.categories);
        });

        // Listen to route param changes
        this.route.params.subscribe(params => {
            const id = params['id'];
            const slug = params['category'];

            if (id) {
                this.categoryService.getCategoryById(id).subscribe((res) => {
                    this.category = res;
                });
            }

            if (slug) {
                this.categoryName = this.slugToTitle(slug);

                this.productService.getProductsFromCategory(this.categoryName).subscribe({
                    next: (res: ServerResponse) => {
                        this.products = res.products;
                    },
                    error: (err) => {
                        console.error('Failed to fetch products:', err);
                    }
                });
            } else {
                // fallback: get all products
                this.productService.getAllProducts().subscribe((prods: ServerResponse) => {
                    this.products = prods.products;
                });
            }
        });
    }

    selectProduct(id: number) {
        this.router.navigate(['product', id]);
    }

    selectCategory(id: number) {
        this.router.navigate(['category', id]);
    }

    AddToCart(id: number) {
        this.cartService.AddProductToCart(id);
    }

    // Convert slug to Title: 'accent-chairs' → 'Accent Chairs'
    slugToTitle(slug: string): string {
        return slug
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    // Convert name to slug: 'Accent Chairs' → 'accent-chairs'
    getSlug(name: string): string {
        return name.toLowerCase().replace(/\s+/g, '-');
    }
}
